import type { AuthedRequester } from "@/lib/brokerAuth";

/** PMS-S761: active prior carriers, unpaged, in PMS order with Other last. */
export interface PriorCarrier {
  id: string;
  name: string;
  isOther: boolean;
}

export function getPriorCarriers(
  request: AuthedRequester,
): Promise<{ items: PriorCarrier[] }> {
  return request<{ items: PriorCarrier[] }>("/api/broker/prior-carriers");
}
